import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePostData } from "../../../../Redux/Slice/createPostSlice";
import { postTypeLimitsService } from "../../../../services/PostTypeLimitsService";
import {
  BUSINESS_FORM_ACTION_ROW_END_CLASS,
} from "../../shared/businessLayoutSpec";
import {
  AdminHeaderAction,
  AdminMetadataText,
  AdminSupportingText,
  AdminFormFieldLabelRow,
} from "../../../AdminDashboard/shared/adminUx";

const PostTypeSelection = ({ setStep, handlePost }) => {
  const dispatch = useDispatch();
  const { postType } = useSelector((state) => state.createPost);
  const user = useSelector((state) => state.user);
  const [selectedType, setSelectedType] = useState(postType || "");
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [postTypeLimits, setPostTypeLimits] = useState({
    standard: 0,
    featured: 0,
    resetDays: 0,
  });

  useEffect(() => {
    if (user.user?.id) {
      const limits = postTypeLimitsService.getLimits(user.user.id);
      setPostTypeLimits(limits);
    }
  }, [user.user?.id]);

  useEffect(() => {
    setIsNextDisabled(!selectedType);
  }, [selectedType]);

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    dispatch(updatePostData({ postType: type }));
  };

  const handleNext = () => {
    if (selectedType) {
      setStep(2);
    }
  };

  const isTypeDisabled = (type) => postTypeLimits[type] === 0;

  const getCounterText = (type) => {
    const count = postTypeLimits[type];
    if (count === 0) {
      return `resets in ${postTypeLimits.resetDays} days`;
    }
    return `${count} post left`;
  };

  const cardClass = (type, selected) => {
    if (isTypeDisabled(type)) {
      return "bg-lightgray cursor-not-allowed opacity-60";
    }
    if (selected) {
      return "bg-lightgray";
    }
    return "bg-mistygray hover:bg-lightgray";
  };

  return (
    <>
      <div className="w-full">
        <div className="space-y-4">
          <div>
            <div className="flex items-start justify-between">
              <AdminFormFieldLabelRow
                className="!mb-0"
                label="Standard Post"
                tooltip="Appears in regular listings with standard visibility"
              />
              <AdminMetadataText
                className={isTypeDisabled("standard") ? "text-mediumgray" : "text-offblack"}
              >
                {getCounterText("standard")}
              </AdminMetadataText>
            </div>
            <div
              className={`w-full h-[48px] rounded p-3 cursor-pointer transition-all duration-200 flex items-center ${cardClass(
                "standard",
                selectedType === "standard"
              )}`}
              onClick={() => !isTypeDisabled("standard") && handleTypeSelect("standard")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  !isTypeDisabled("standard") && handleTypeSelect("standard");
                }
              }}
              role="button"
              tabIndex={isTypeDisabled("standard") ? -1 : 0}
            >
              <AdminSupportingText className="text-offblack">
                Appears in regular listings
              </AdminSupportingText>
            </div>
          </div>

          <div>
            <div className="flex items-start justify-between">
              <AdminFormFieldLabelRow
                className="!mb-0"
                label="Featured Post"
                tooltip="Shown above regular posts with enhanced visibility and priority placement"
              />
              <AdminMetadataText
                className={isTypeDisabled("featured") ? "text-mediumgray" : "text-offblack"}
              >
                {getCounterText("featured")}
              </AdminMetadataText>
            </div>
            <div
              className={`w-full h-[48px] rounded p-3 cursor-pointer transition-all duration-200 flex items-center ${cardClass(
                "featured",
                selectedType === "featured"
              )}`}
              onClick={() => !isTypeDisabled("featured") && handleTypeSelect("featured")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  !isTypeDisabled("featured") && handleTypeSelect("featured");
                }
              }}
              role="button"
              tabIndex={isTypeDisabled("featured") ? -1 : 0}
            >
              <AdminSupportingText className="text-offblack">Shown above regular posts</AdminSupportingText>
            </div>
          </div>
        </div>
      </div>

      <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
        <AdminHeaderAction type="button" onClick={handleNext} disabled={isNextDisabled}>
          Next
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default PostTypeSelection;
